export const CLINICAL_ROLES = [
  "Practitioner",
  "Medical Assistant",
  "Nurse Practitioner",
  "Registered Nurse",
  "Medical Director",
];

export const OPERATIONS_ROLES = [
  "Clerical Staff",
  "File Manager",
  "Encounter Viewer",
];

export const MEDICAL_ROLES = [
  ...CLINICAL_ROLES,
  "Encounter Viewer",
  "File Manager",
];

export const ADMIN_ROLES = ["Administrator"];

export const CLINICAL_REVENUE_ADMIN_ROLES = ["Clinical Revenue Administrator"];

export const SUBSCRIPTION_MANAGER_ROLES = ["Subscription Manager"];

export const EXECUTIVE_ROLES = ["Executive"];

const normalizeRole = (role: string): string =>
  role.toLowerCase().replace(/_/g, " ").trim();

export const ALL_ROLES = [
  ...CLINICAL_ROLES,
  ...MEDICAL_ROLES,
  ...ADMIN_ROLES,
  ...SUBSCRIPTION_MANAGER_ROLES,
  ...CLINICAL_REVENUE_ADMIN_ROLES,
  ...OPERATIONS_ROLES,
];

// eslint-disable-next-line import/prefer-default-export
export const canWriteMedicalInfo = (userRoles: string[]) =>
  userRoles?.length
    ? userRoles.some((role) => CLINICAL_ROLES.includes(role))
    : false;

export const isEncounterViewerOnly = (userRoles: string[]) => {
  const hasEncounterViewer = userRoles?.includes("Encounter Viewer");
  const hasMedicalRole = userRoles?.some((role) =>
    CLINICAL_ROLES.includes(role),
  );
  return hasEncounterViewer && !hasMedicalRole;
};

export const hasBillingAccess = (userRoles: string[]) =>
  userRoles?.includes("Clinical Revenue Administrator");

export const isMedicalStaff = (userRoles: string[]) =>
  userRoles?.some((role) => CLINICAL_ROLES.includes(role));

export const isSubscriptionManagerRole = (role: string): boolean =>
  normalizeRole(role) === "subscription manager";

export const hasSubscriptionManagerRole = (
  userRoles?: string[] | null,
): boolean => userRoles?.some(isSubscriptionManagerRole) ?? false;

export const hasAdministratorRole = (userRoles?: string[] | null): boolean =>
  userRoles?.some((role) => {
    const normalizedRole = normalizeRole(role);
    return normalizedRole === "administrator" || normalizedRole === "admin";
  }) ?? false;

export const hasSuperAdministratorRole = (
  userRoles?: string[] | null,
): boolean =>
  userRoles?.some((role) => normalizeRole(role) === "super administrator") ??
  false;

/** Paid subscription seats are Practitioner-only (matches subscription-svc). */
export const hasPaidSeatRole = (userRoles?: string[] | null): boolean =>
  userRoles?.some((role) => role === "Practitioner") ?? false;

/** Null-safe Auth0/named-role variant of hasPaidSeatRole. */
export const hasPaidSeatNamedRoles = (
  roles?: ReadonlyArray<{ name: string }> | null,
): boolean => hasPaidSeatRole(roles?.map((role) => role.name));
